import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  physicalVouchers: [],
};

export const physicalVoucherSlice = createSlice({
  name: "vouchersList",
  initialState,
  reducers: {
    updateVoucherList(state, action) {
      state.physicalVouchers = action.payload.physicalVouchers;
    },
    resetRoleSlice: (state) => initialState,
  },
});
export const physicalVoucherAuctions = physicalVoucherSlice.actions;
export default physicalVoucherSlice.reducer;
